import React, { useEffect } from "react";
import { Container, Row, Col, Card, Table } from "react-bootstrap";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { FaUsers, FaMoneyBillWave, FaChartLine } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../home.css";
import { useSelector, useDispatch } from "react-redux";
import {
  getActivity,
  getUser,
  getDashData,
  getDashRegistartion,
  getDashSubscription,
  getDashSummary,
} from "../../store/slices/user";

export default function Dashboard() {
  const dispatch = useDispatch();
  const { activityList, loading } = useSelector((state) => state.user);
  const { userlist = [] } = useSelector((state) => state.user);

  const { summaryData = [] } = useSelector((state) => state.user);
  const { subscriberData = [] } = useSelector((state) => state.user);
  const { salesData = [] } = useSelector((state) => state.user);
  const { dashStats = [] } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(
      getActivity({
        page: 1,
        limit: 5,
      }),
    ).then((res) => { });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getUser({ page: 1, limit: 5 })).then((res) => { });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashData()).then((res) => { });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashRegistartion()).then((res) => { });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashSubscription()).then((res) => { });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getDashSummary()).then((res) => { });
  }, [dispatch]);

  return (
    <>
      <Container className="p-3 bg-light min-vh-100 my-4 dashboard-home ">
        <Row className="g-3">
          <Col md={4} sm={12}>
            <Card className="premium-card">
              <Card.Body className="card-body-flex">
                <div>
                  <h6 className="card-label">Total Profiles</h6>
                  <h4 className="card-number">{dashStats?.totalActiveUsers}</h4>
                </div>

                <div className="icon-box orange">
                  <FaUsers />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} sm={12}>
            <Card className="premium-card">
              <Card.Body className="card-body-flex">
                <div>
                  <h6 className="card-label">Total Revenue</h6>
                  <h4 className="card-number">
                    ₹ {dashStats?.totalRevenue}
                  </h4>
                </div>

                <div className="icon-box yellow">
                  <FaMoneyBillWave />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} sm={12}>
            <Card className="premium-card">
              <Card.Body className="card-body-flex">
                <div>
                  <h6 className="card-label">Active Subscription</h6>
                  <h4 className="card-number">
                    {dashStats?.totalActiveSubscriptions}
                  </h4>
                </div>

                <div className="icon-box gradient">
                  <FaChartLine />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3 g-3">
          <Col lg={6} md={12}>
            <Card className="dashboard-card">
              <Card.Body>
                <div className="card-header-custom">
                  <div>
                    <h6 className="card-title">Registration</h6>
                  </div>
                </div>

                <ResponsiveContainer width="100%" height={250}>
                  <LineChart data={salesData}>
                    <XAxis dataKey="name" stroke="#aaa" />
                    <YAxis stroke="#aaa" />
                    <Tooltip />

                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="#7a1232"
                      strokeWidth={3}
                      dot={{ r: 4 }}
                      activeDot={{ r: 6 }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6} md={12}>
            <Card className="dashboard-card">
              <Card.Body>
                <div className="card-header-custom">
                  <div>
                    <h6 className="card-title">Subscription Overview</h6>
                  </div>
                </div>

                <ResponsiveContainer width="100%" height={250}>
                  <BarChart data={subscriberData}>
                    <XAxis dataKey="name" stroke="#aaa" />
                    <YAxis stroke="#aaa" />
                    <Tooltip />

                    <Bar
                      dataKey="value"
                      radius={[10, 10, 0, 0]}
                      fill="url(#colorGradient)"
                    />
                    <defs>
                      <linearGradient
                        id="colorGradient"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop offset="0%" stopColor="#7a1232" />
                        <stop offset="100%" stopColor="#ff5722" />
                      </linearGradient>
                    </defs>
                  </BarChart>
                </ResponsiveContainer>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-3 g-3 my-4">
          <Col md={12} sm={12}>
            <Card className="customtable-card">
              <h6 className="my-4 mx-3">Recent Registrations</h6>

              <div className="table-responsive">
                <Table className="custom-table align-middle">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Gender</th>
                      <th>Sub Caste</th>
                      <th>Age</th>
                      <th>Profile For</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {userlist.map((u, index) => (
                      <tr key={index}>
                        <td className="index">{index + 1}</td>

                        <td>
                          <div>
                            <div>{u.name}</div>
                          </div>
                        </td>

                        <td>{u.gender}</td>
                        <td>{u.subCaste}</td>
                        <td>{u.age}</td>
                        <td>{u.profileFor}</td>

                        <td>
                          <span
                            className={`cl-badge ${u.isActive ? "cl-badge--active" : "cl-badge--inactive"}`}
                          >
                            <span className="cl-badge-dot" />
                            {u.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card>
          </Col>
        </Row>

        <Row className="my-2">
          <Col lg={6}>
            <div className="ar-live-box">
              <div className="ar-live-head">
                <span className="dot-live"></span> Activity
              </div>

              <div className="ar-live-list">
                {(activityList || []).map((item, i) => {
                  const name = item.fromUser?.name || "User";
                  const toName = item.toUser?.name || "";

                  let actionText = "";
                  let icon = "💬";
                  let color = "#7a1232";

                  if (item.type === "INTEREST_SENT") {
                    actionText = `sent a match request to ${toName}`;
                    icon = "💞";
                    color = "#F97316";
                  } else if (item.type === "INTEREST_ACCEPTED") {
                    actionText = `accepted request from ${toName}`;
                    icon = "✅";
                    color = "#10B981";
                  } else if (item.type === "INTEREST_REJECTED") {
                    actionText = `rejected request from ${toName}`;
                    icon = "❌";
                    color = "#EF4444";
                  } else if (item.type === "SHORTLISTED") {
                    actionText = `shortlisted ${toName}`;
                    icon = "⭐";
                    color = "#F59E0B";
                  } else {
                    actionText = item.type;
                  }

                  const timeAgo = new Date(item.createdAt).toLocaleTimeString();

                  return (
                    <div key={item._id || i} className="ar-live-item">
                      <div className="ar-live-left">
                        <div
                          className="ar-live-avatar"
                          style={{ background: color }}
                        >
                          {name?.charAt(0)?.toUpperCase()}
                        </div>

                        <div>
                          <div className="ar-live-text">
                            <span className="name">{name}</span> {actionText}
                          </div>
                          <div className="ar-live-time">{timeAgo}</div>
                        </div>
                      </div>

                      <div className="ar-live-icon">{icon}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <div className="ar-summary-box">
              <div className="ar-summary-head">📋 Today's Summary</div>

              <div className="ar-summary-body">
                {summaryData.map((item, i) => (
                  <div key={i} className="ar-summary-row">
                    <div className="ar-summary-left">
                      <span className="ar-summary-icon">{item.icon}</span>
                      <span className="ar-summary-label">{item.label}</span>
                    </div>

                    <div className="ar-summary-bar">
                      <div
                        className="ar-summary-fill"
                        style={{ width: item.width }}
                      ></div>
                    </div>

                    <div className="ar-summary-value">{item.value}</div>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
